import React, { useMemo } from "react";
import { useSelector } from "react-redux";

/**
 * Hook: useAuditAssignment
 * Params
 * 1. Current asset audit  location id
 * 2. Asset is of same group
 * 3. Current asset audit refence
 * 4. Current asset audit location id
 * 5. Current audit location
 */
const useAuditAssignment = ({
    auditLocationId,
    assetOfSameGroup,
    assetAuditReference,
    currentAuditLocation,
    isGroupAudit,
}) => {
    const { auditAssignments } = useSelector((state) => state);

    const assignment = useMemo(() => {
        const res = auditAssignments.data.find(
            (item) => item.auditLocation.id === auditLocationId
        );

        if (!auditAssignments?.data) return null;

        if (assetOfSameGroup && auditLocationId) return res;

        if (!assetOfSameGroup && auditLocationId && isGroupAudit) {
            const assetLocation = auditAssignments.data
                .filter(
                    (item) =>
                        item.auditLocation.audit.auditReference ===
                        assetAuditReference
                )
                .find(
                    (item) =>
                        item.auditLocation.location.id === currentAuditLocation
                );

            return assetLocation || res;
        }

        return res;
    }, [
        auditAssignments,
        auditLocationId,
        assetOfSameGroup,
        assetAuditReference,
        currentAuditLocation,
    ]);

    return assignment;
};

export default useAuditAssignment;
